"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hooks = require("../../utils/hooks");

var _Announcement = _interopRequireWildcard(require("../Announcement"));

var _Banner = require("../Banner");

var _ComponentWrapper = _interopRequireDefault(require("../ComponentWrapper"));

var _LivePlayerContent = _interopRequireWildcard(require("./LivePlayerContent"));

var _VideoEmbed = require("./VideoEmbed");

var _VideoOverlay = require("./VideoOverlay");

var LivePlayer = function LivePlayer(_ref) {
  var announcement = _ref.announcement,
      interactionTool = _ref.interactionTool,
      liveTitleUrl = _ref.liveTitleUrl,
      overlay = _ref.overlay,
      type = _ref.type,
      videoUrl = _ref.videoUrl;
  var hasMounted = (0, _hooks.useHasMounted)();

  if (!hasMounted) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LivePlayerContent.default, {
    interactionTool: interactionTool,
    liveTitleUrl: liveTitleUrl,
    type: type,
    overlay: overlay,
    videoUrl: videoUrl
  }), announcement && /*#__PURE__*/_react.default.createElement(_ComponentWrapper.default, {
    columnWidth: [12]
  }, /*#__PURE__*/_react.default.createElement(_Announcement.default, announcement)));
};

LivePlayer.propTypes = {
  announcement: _propTypes.default.shape(_Announcement.announcementPropTypes),
  interactionTool: _propTypes.default.shape({
    banner: _propTypes.default.shape(_Banner.bannerPropTypes),
    handleToggleClick: _propTypes.default.func,
    type: _propTypes.default.oneOf(Object.values(_LivePlayerContent.LivePlayerInteractionType)),
    url: _propTypes.default.string,
    user: _propTypes.default.shape({
      email: _propTypes.default.string,
      firstName: _propTypes.default.string,
      company: _propTypes.default.string,
      loggedIn: _propTypes.default.bool
    })
  }),
  liveTitleUrl: _propTypes.default.string,
  type: _propTypes.default.oneOf(Object.values(_VideoEmbed.LivePlayerType)),
  overlay: _propTypes.default.shape(_VideoOverlay.videoEmbedOverlayProps),
  videoUrl: _propTypes.default.string.isRequired
};
LivePlayer.defaultProps = {
  announcement: null,
  interactionTool: null,
  liveTitleUrl: '',
  type: _VideoEmbed.LivePlayerType.embed,
  overlay: null
};
var _default = LivePlayer;
exports.default = _default;